import Vue from 'vue';
import ProductsInventum from '~/pages/products/inventum.vue';
import RasylvaApi from '~/plugins/rasylva-api';
import createStore from '~/store';

Vue.use(RasylvaApi);

document.addEventListener('DOMContentLoaded', () => {
  if (document.getElementById('products-inventum-wrapper')) {
    new Vue({
      store: createStore(),
      render: (h) => h(ProductsInventum),
    }).$mount('#products-inventum-wrapper');
  }
});
